import validate from "/home/runner/work/octo/octo/node_modules/.pnpm/nuxt@3.2.0_dq2illufn2sdyxstnqbjq3sy6i/node_modules/nuxt/dist/pages/runtime/validate.mjs";
import analytics_45global from "/home/runner/work/octo/octo/middleware/analytics.global.ts";
import redirects_45global from "/home/runner/work/octo/octo/middleware/redirects.global.ts";
export const globalMiddleware = [
  validate,
  analytics_45global,
  redirects_45global
]
export const namedMiddleware = {}